module.exports = __webpack_public_path__ + "img/Identity-Pattern4.3281d4c1.jpg";